<ngb-pagination
  *ngIf="paging.count > paging.pageSize"
  [collectionSize]="paging.count"
  [pageSize]="paging.pageSize"
  [(page)]="paging.currentPage"
  [maxSize]="20"
  (pageChange)="onPageChange($event)"
  [directionLinks]="true"
/>
